/**
 * File: servicesDropDown.js
 * Origin: isotect
 * Description: [TODO: Description]
 *
 * Version: v3.0.4
 * Created: 2025-12-04
 * Last Updated: 2026-06-22
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

// Local project files
import { routes } from "../../constants/routes";

// Services DropDown
export const serviceDropDown = {
    id: "services-dropdown",
    label: "SERVICES",
    featureText: "Browse by service",
    features: [
        {
            id: "feature-sdd-1",
            link: routes.public.services.surveying.abs,
            image: "../svgs/dropdown_services_surveying-icon.svg",
            header: "SURVEYING",
            description:
                "Accurate field measurements and detailed site observation reports.",
        },
        {
            id: "feature-sdd-2",
            link: routes.public.services.drafting.abs,
            image: "../svgs/dropdown_services_drafting-icon.svg",
            header: "DRAFTING",
            description:
                "Professional MEP drafting and BIM coordination for any project.",
        },
        {
            id: "feature-sdd-3",
            link: routes.public.services.engineering.abs,
            image: "../svgs/dropdown_services_engineering-icon.svg",
            header: "ENGINEERING",
            description: "Mechanical and plumbing engineering support.",
        },
        {
            id: "feature-sdd-4",
            link: routes.public.services.qaqc.abs,
            image: "../svgs/dropdown_services_qaqc-review-icon.svg",
            header: "QA/QC REVIEW",
            description:
                "Engineering review services to improve constructability.",
        },
    ],
    actionImage: "./svgs/dropdown_services_building-isometric.svg",
    actionHeader: "Upgrade Your Engineering Workflow",
    actionDescription:
        "Access surveying, drafting, engineering, and QAQC support whenever you need it.",
    actionButtonText: "Browse all services",
    actionButtonLink: routes.public.services.root,
};
